import React from "react";
import { useHistory } from "react-router-dom";
import oopsImage from "src/assets/oops.svg";

export default function Subscription() {
    const history = useHistory();

    return (
        <>
            <div className="d-flex justify-content-center align-items-center flex-column w-100 docg-vh-standard">
                <img style={{ maxHeight: "30vh" }} src={oopsImage} alt="" />
                <br />
                <br />
                <p className="h5 text-center">
                    Your clinic does not have an active subscription.
                    <br />
                    <br />
                    Please click on the subscribe button below to start your clinic account.
                    <br />
                </p>
                <br />
                <button onClick={() => history.push('/subscription')} className="docg-save-btn">
                    Subscribe
                </button>
            </div>
        </>
    );
}
